import React from "react";
import classes from "./tags.module.css";
// @ts-ignore
import mergeClassNames from "merge-class-names";

function Tags(props: { tags: string[]; className?: string; label?: string }) {
  const { tags = [], className, label = "Từ khóa:" } = props;
  
  if (!tags.length) return null;
  
  return (
    <div className={mergeClassNames(classes.root, className || "")}>
      <span className={classes.label}>{label}</span>
      <div className={classes.tagsContainer}>
        {tags.map((tag, index) => (
          <span key={index} className={classes.tag}>
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Tags;
